export * from './graphClickCollect.component';
